import { viewer } from 'src/main';
import { RefCounted } from 'neuroglancer/util/disposable';
import './cell_shape_mode.less';
import i18n from '../i18n/i18n';

interface modeOption {
  name:string
  value: string
}

export class cellShapeModeWidget extends RefCounted {
  element = document.createElement('div');
  constructor(){
    super();
    this.element.className = 'neuroglancer-layer-control-container cell-cluster-control-wrap';
    this.initCellModeSelect();
    this.initBorderColorSelect()
  }
  initCellModeSelect(){
    let controlWrap = document.createElement('div');
    controlWrap.className = 'cell-cluster-control';

    this.element.append(controlWrap);
    let shapeModeLabel = document.createElement('div');
    shapeModeLabel.className = 'neuroglancer-layer-control-label-container';
    shapeModeLabel.innerText = i18n.layerPanelFormCell;
    controlWrap.append(shapeModeLabel);
    const selectEl = document.createElement('select');
    selectEl.className = 'neuroglancer-layer-control-control cell-setting-select';

    controlWrap.append(selectEl);

    this.registerEventListener(selectEl, 'change', () => {
      viewer.cellShowMode.value = selectEl.value;
      viewer.resetoreJson(viewer.state.toJSON());
    });

    const options = [
      {
        name: i18n.layerPanelFilled,
        value: 'filled'
      },
      {
        name: i18n.layerPanelBoth,
        value: 'both'
      },
      {
        name: i18n.layerPanelOutlined,
        value: 'outlined'
      }
    ];

    options.forEach((item:modeOption)=>{
      {
        const option = document.createElement('option');
        option.textContent = item.name;
        option.value = item.value;
        selectEl.appendChild(option);
      }
    });

    selectEl.value = viewer.cellShowMode.value!;
  }
  initBorderColorSelect(){
    let controlWrap = document.createElement('div');
    controlWrap.className = 'cell-cluster-control';

    this.element.append(controlWrap);
    let shapeModeLabel = document.createElement('div');
    shapeModeLabel.className = 'neuroglancer-layer-control-label-container';
    shapeModeLabel.innerText = i18n.layerPanelOutlineColor;
    controlWrap.append(shapeModeLabel);
    const selectEl = document.createElement('select');
    selectEl.className = 'neuroglancer-layer-control-control cell-setting-select';

    controlWrap.append(selectEl);

    this.registerEventListener(selectEl, 'change', () => {
      viewer.outLineColor.value = selectEl.value;
      viewer.resetoreJson(viewer.state.toJSON());
    });
    const options = [ {name: i18n.layerPanelCluster, value: 'Cluster'},
      {name: i18n.layerPanelWhite, value: 'White'},
      {name: i18n.layerPanelBlack, value: 'Black'},
      {name: i18n.layerPanelGreen, value: 'Green'} ];

    options.forEach((item)=>{
      {
        const option = document.createElement('option');
        option.textContent = item.name;
        option.value = item.value;
        selectEl.appendChild(option);
      }
    });
    selectEl.value = viewer.outLineColor.value!;
  }
}
